import { createSelector } from 'reselect';
import { currentBotSelector } from '.';

export const aiToolsSelector = createSelector(
  currentBotSelector,
  bot => bot.aiTools || []
);
